// Generated by CoffeeScript 2.7.0
// -- checkbox
// value: [option1, option2, ... {value: '其他', selected: true}]
// value: []
// -- radio
// value: optionx
// value: null
// value: { value: '其他', selected: true }
var option_item_comp, option_item_mixin, other_option_item_comp;

export var OptionItemMixin = {
  props: ['option', 'typeClass', 'selected', 'disabled'],
  computed: {
    checked: function() {
      var ref;
      if (this.selected instanceof Array) {
        return this.selected.some((item) => {
          var ref;
          return this.option.id.toString() === ((ref = item.id) != null ? ref.toString() : void 0);
        });
      } else {
        if (!this.selected) {
          return false;
        }
        return this.option.id.toString() === ((ref = this.selected.id) != null ? ref.toString() : void 0);
      }
    }
  },
  methods: {
    change: function(event) {
      var checked;
      if (this.option._disabled) {
        return event.preventDefault();
      } else {
        checked = event.target.checked;
        return this.$emit('valueChange', this.option, checked);
      }
    },
    preventIfNeed: function(event) {
      if (this.option._disabled) {
        return event.preventDefault();
      }
    }
  }
};

export var OptionListMixin = {
  props: ['options', 'initValue', 'hasOtherOption', 'multiple', 'optionsClass', 'otherOptionDisabled', 'disabled', 'isFormFieldOption', 'searchable'],
  data: function() {
    return {
      otherOption: {
        selected: false,
        value: ''
      },
      value: this.initValue
    };
  },
  computed: {
    typeClass: function() {
      if (this.multiple) {
        return 'slp-square-o';
      } else {
        return 'slp-circle-o';
      }
    }
  },
  watch: {
    initValue: {
      immediate: true,
      handler: function() {
        return this.value = this.initValue;
      }
    }
  },
  methods: {
    valueChange: function(option, checked) {
      var old_option;
      if (this.multiple) {
        this.value = this.value || [];
        if (checked) {
          old_option = _.find(this.value, function(_item) {
            if (option.id) {
              return _item.id.toString() === option.id.toString();
            } else {
              return !_item.id;
            }
          });
          if (!old_option) {
            this.value.push(option);
          }
        } else {
          this.value = _.reject(this.value, function(_item) {
            // 普通选项
            if (option.id) {
              return _item.id.toString() === option.id.toString();
            } else {
              // 其他选项
              return _item.id === void 0;
            }
          });
        }
      } else {
        if (checked) {
          this.value = option;
          if (this.value !== this.otherOption) {
            // 其他选项失去选中时(选了普通选项),其他选项需要变为unselected状态
            this.otherOption.selected = false;
          }
        } else {
          this.value = null;
        }
      }
      return this.$emit('valueChange', this.value);
    },
    otherOptionChange: function(event) {
      var checked;
      checked = event.target.checked;
      return this._setOtherOptionSelected(checked);
    },
    _setOtherOptionSelected: function(checked) {
      var old_otherOption_status;
      old_otherOption_status = this.otherOption.selected;
      this.otherOption.selected = checked;
      if (old_otherOption_status === checked) {
        return;
      }
      return this.valueChange(this.otherOption, checked);
    },
    toggleOtherOption: function() {
      if (this.otherOptionDisabled || this.disabled) {
        return;
      }
      if (this.otherOption.value) {
        this._setOtherOptionSelected(!this.otherOption.selected);
        return this.$refs.other_option_input[this.otherOption.selected ? 'focus' : 'blur']();
      } else {
        this._setOtherOptionSelected(true);
        return this.$refs.other_option_input.focus();
      }
    },
    otherOptionFocused: function(event) {
      if (this.otherOptionDisabled || this.disabled) {
        return;
      }
      this._setOtherOptionSelected(true);
      return this.$refs.other_option_input.focus();
    },
    otherOptionUpdate: function(event) {
      var value;
      value = event.target.value;
      this.otherOption.value = value;
      return this.valueChange(this.otherOption, this.otherOption.selected);
    },
    otherOptionBlured: function(event) {
      var value;
      value = event.target.value;
      this.otherOption.value = value;
      this.otherOption.selected = Boolean(this.otherOption.selected && value.length);
      return this.valueChange(this.otherOption, this.otherOption.selected);
    },
    reset: function() {
      this.value = this.initValue;
      return this._parseOtherOption();
    },
    _parseOtherOption: function() {
      var other_option;
      if (!this.hasOtherOption) {
        return;
      }
      if (this.multiple) {
        other_option = _.find(this.initValue, function(_item) {
          return _item.id === void 0;
        }) || {
          value: ''
        };
      } else {
        other_option = ((this.initValue != null) && !this.initValue.id && this.initValue.value) ? this.initValue : {
          value: ''
        };
      }
      other_option.selected = Boolean(other_option.value);
      return this.otherOption = other_option;
    }
  },
  created: function() {
    return this._parseOtherOption();
  }
};

option_item_mixin = {
  props: {
    option: {
      type: [Skylark.App.Model.FieldOption, Skylark.App.Model.FieldOptionProxy],
      required: true
    },
    typeClass: String,
    selectedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    checked: function() {
      return _.any(this.selectedOptions, (item) => {
        return item === this.option;
      });
    },
    optionDisabled: function() {
      return this.disabled || this.limitReached;
    },
    limitReached: function() {
      return !this.checked && this.option.limitReached();
    }
  },
  watch: {
    checked: function(new_val) {
      if (new_val) {
        return this.option.incrementCounter();
      } else {
        return this.option.decrementCounter();
      }
    },
    limitReached: function(new_val) {
      if (new_val) {
        return this.$nextTick(function() {
          return this.$emit('valueChange', this.option, false);
        });
      }
    }
  },
  created: function() {
    this.label = this.option.textValue(this.checked);
    if (this.checked) {
      this.option.incrementCounter();
      if (this.option.isOverLimit()) {
        return this.$nextTick(function() {
          return this.$emit('valueChange', this.option, false);
        });
      }
    }
  },
  methods: {
    preventIfNeed: function(event) {
      if (this.optionDisabled) {
        return event.preventDefault();
      }
    }
  }
};

other_option_item_comp = {
  name: 'other-option-item',
  mixins: [option_item_mixin],
  props: {
    option: {
      type: Skylark.App.Model.FieldOptionProxy,
      required: true
    }
  },
  template: `<div class="option-item other-option"
     :class='{ "option-disabled": optionDisabled }' >
  <label class="option-label-wrapper">
    <input type="checkbox"
            hidden="true"
            :checked="checked"
            :disabled='optionDisabled'
            @change='changeFunc' />
    <i :class="typeClass"></i>
    <span class="option-label">{{ label }}</span>
  </label>
  <div class="other-input" @click.stop="inputFocusFunc">
    <input type="text"
           placeholder="请输入"
           :disabled='optionDisabled'
           :value="option.value"
           ref="inputRef"
           @input='inputChangeFunc' />
  </div>
</div>`,
  watch: {
    checked: function(new_val) {
      if (new_val) {
        return this.inputFocusFunc();
      }
    }
  },
  methods: {
    inputFocusFunc: function() {
      if (this.optionDisabled) {
        return;
      }
      if (!this.checked) {
        this.$emit('valueChange', this.option, true);
      }
      return this.$refs.inputRef.focus();
    },
    changeFunc: function(event) {
      return this.$emit('valueChange', this.option, event.target.checked);
    },
    inputChangeFunc: function(event) {
      this.option.value = event.target.value;
      return this.$emit('valueChange', this.option, this.checked);
    }
  }
};

option_item_comp = {
  name: 'option-item',
  mixins: [option_item_mixin],
  template: `<label class="option-item"
       :class='{ "option-disabled": optionDisabled }'
       @click='preventIfNeed'>
  <input type="checkbox" hidden='true' :checked='checked' @change.stop='changeFunc' :disabled='optionDisabled' />
  <i :class="typeClass"></i>
  <span class="option-item-name">{{ label }}</span>
</label>`,
  props: {
    option: {
      type: Skylark.App.Model.FieldOption,
      required: true
    }
  },
  methods: {
    changeFunc: function(event) {
      return this.$emit('valueChange', this.option, event.target.checked);
    }
  }
};

export var Options = Vue.extend({
  name: 'options',
  components: {
    'option-item': option_item_comp,
    'other-option-item': other_option_item_comp
  },
  template: `<div class="options" :class='optionsClass'>
  <option-item v-for="option in options"
               :key='option.id'
               :option='option'
               :typeClass='typeClass'
               :selectedOptions="selectedOptions"
               :disabled='disabled'
               @valueChange="valueChangeFunc" />
  <other-option-item v-if='otherOption'
                     :option='otherOption'
                     :typeClass='typeClass'
                     :selectedOptions="selectedOptions"
                     :disabled='disabled'
                     @valueChange="valueChangeFunc" />
</div>`,
  props: {
    options: Array,
    otherOption: {
      type: Skylark.App.Model.FieldOptionProxy
    },
    initialSelectedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    optionsClass: [String, Object],
    disabled: {
      type: Boolean,
      default: false
    },
    customIcon: String
  },
  data: function() {
    return {
      selectedOptions: this.initialSelectedOptions
    };
  },
  computed: {
    typeClass: function() {
      if (this.customIcon) {
        return this.customIcon;
      } else {
        if (this.multiple) {
          return 'slp-square-o';
        } else {
          return 'slp-circle-o';
        }
      }
    }
  },
  methods: {
    valueChangeFunc: function(option, checked) {
      var is_selected;
      if (this.multiple) {
        if (checked) {
          is_selected = _.any(this.selectedOptions, function(item) {
            return item === option;
          });
          if (!is_selected) {
            this.selectedOptions.push(option);
          }
        } else {
          this.selectedOptions = _.without(this.selectedOptions, option);
        }
      } else {
        if (checked) {
          this.selectedOptions = [option];
        } else {
          this.selectedOptions = [];
        }
      }
      return this.$emit('valueChange', this.selectedOptions);
    },
    reset: function() {
      return this.selectedOptions = this.initialSelectedOptions;
    }
  }
});

export default Options;
